export interface TenderCostsRange {
    /** Amount stored in `tenderCosts` when this range is picked: its lower bound. */
    value: number;
    label: string;
}

/**
 * Tender costs are picked as a range, but the backend still stores a single amount. Amounts entered
 * before the picklist existed fall into the range whose lower bound they reach.
 */
export const TENDER_COSTS_RANGES: readonly TenderCostsRange[] = [
    {value: 0, label: '< € 25.000'},
    {value: 25_000, label: '€ 25.000 – € 75.000'},
    {value: 75_001, label: '€ 75.001 – € 150.000'},
    {value: 150_001, label: '€ 150.001 – € 300.000'},
    {value: 300_001, label: '> € 300.000'}
];

export function findTenderCostsRange(amount: number | null | undefined): TenderCostsRange | null {
    if (amount === null || amount === undefined) {
        return null;
    }

    return TENDER_COSTS_RANGES.filter((range) => amount >= range.value).at(-1) ?? TENDER_COSTS_RANGES[0];
}
